 <app-loader [isInline]="true" [hasTransparency]="true" [loaderMessage]="'Loading step data...'" *ngIf="isLoading && !hideLoaded" ></app-loader>
 <div class="photos-wrapper">
		<div class="photos-list">
			<p *ngIf="!isLoading && !photos.length" class="empty-message-container">No Photos</p>
			<ng-container *ngIf="!isLoading && photos.length > 0">
				<div  class="photo-container" *ngFor="let photo of photos">
					<div class="thumbnail" (click)="loadDocument(photo)">
						<img [class.no-thumbnail]="!photo.imageThumbnail" [src]="imageThumbnail(photo)" />
					</div>
					<div class="details">
						<div class="details-grid">
							<div class="item-label">Date:</div>
							<div class="item-details">{{formatDate(photo.createdOn)}}</div>
							<div class="item-label">Field:</div>
							<div class="item-details">								
								<div class="field-name" *ngIf="!photo.measurementName" [matTooltip]="photo.measurementName" style="font-size: 16px;">{{photo.measurementName}}</div>														
								<div class="field-name disabled">n/a</div>
							</div>						
						</div>
					</div>				
				</div>
			</ng-container>
		</div>
	</div>

<generic-modal #photoModal [isFullHeight]="true" [hideOnBackdropClick]="false" [overlayClass]="'photo-preview-modal'" [onHide]="onPhotoModalHide">
  	<ng-template #modalBody>
		<app-loader [isInline]="true" [hasTransparency]="true" [loaderMessage]="'Loading photo...'" *ngIf="isPhotoLoading" ></app-loader>
		<ng-container *ngIf="!isPhotoLoading">
			<app-document-viewer #photoPreviewViewer class="photo-preview-viewer" [documentDetails]="documentDetails"
				[afterWebViewerRender]="afterWebViewerRender.bind(self)">
			</app-document-viewer>
		</ng-container>
	</ng-template>

	<ng-template #modalActions>
		<button mat-flat-button (click)="photoModal.hide()">Close</button>
	</ng-template>
</generic-modal>